import { SvgIcon } from '@mui/material';

export default function EmergencyResponsePlanningIcon(props) {
  return (
    <SvgIcon {...props} >
      {/* Main icon paths */}
      <path
        d="M14.433 17.8087C12.326 18.9193 9.67432 18.9194 7.5658 17.8087L9.32458 14.7052C9.83699 14.9803 10.4119 15.1256 10.9994 15.1241V15.1251L11.0004 15.1241L11.0023 15.1251L11.0013 15.1241C11.5885 15.1255 12.163 14.98 12.6752 14.7052L14.433 17.8087ZM11.0004 9.00009C11.5307 9.0002 12.0395 9.21105 12.4144 9.58603C12.7893 9.96108 13.0004 10.4698 13.0004 11.0001C13.0003 11.5304 12.7894 12.0391 12.4144 12.4142C12.0395 12.7891 11.5307 13 11.0004 13.0001C10.4699 13.0001 9.9604 12.7892 9.58533 12.4142C9.21043 12.0391 9.00039 11.5304 9.00037 11.0001C9.00037 10.4698 9.21046 9.96107 9.58533 9.58603C9.9604 9.21096 10.4699 9.00009 11.0004 9.00009ZM15.0804 4.65634C17.0967 5.92573 18.4223 8.22239 18.515 10.6036L14.9476 10.6329C14.9326 10.1476 14.8184 9.66978 14.6088 9.22958L14.473 8.97177C14.1807 8.46265 13.7679 8.0367 13.2738 7.73056L15.0804 4.65634ZM8.72595 7.66025C8.23211 7.96633 7.81897 8.39155 7.52673 8.90048C7.23105 9.4086 7.0695 9.97993 7.05115 10.5616L3.48376 10.5323C3.57576 8.15234 4.90204 5.85637 6.91736 4.58603L8.72595 7.66025Z"
        stroke="currentColor"
        fill="none"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      {/* Outer outline circle */}
      <path
        d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 16.523 5.477 21 11 21Z"
        stroke="currentColor"
        fill="none"
      />
    </SvgIcon>
  );
}